import { useQuery } from '@tanstack/react-query';
import instanceAxios from '@/util/axios';

export interface AgentToolSummary {
  name: string;
  description: string;
  method: string;
  path: string;
  sideEffect: 'read' | 'write';
  documented: boolean;
}

export interface AgentToolsResponse {
  total: number;
  reads: number;
  writes: number;
  tools: AgentToolSummary[];
}

const getAgentTools = async (): Promise<AgentToolsResponse> => {
  const { data } = await instanceAxios.get<AgentToolsResponse>('pvt/agent/tools');
  return data;
};

/**
 * What the chat can do for the current user. Used to decide whether to render the launcher at
 * all: a role without `agent:use` gets a 403 here, which is the cheapest way to ask.
 */
export const useAgentTools = (enabled = true) =>
  useQuery<AgentToolsResponse>({
    queryKey: ['agent', 'tools'],
    queryFn: getAgentTools,
    enabled,
    retry: false,
    staleTime: Infinity
  });
